export const USER_MSG = {
	name: '根据账号ID查询账号详情',
	api: '${BASE}/bcp-basic-data-dev/api/B/account/info',
  doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612161',
};
export const RESET_PASSWORD = {
  name: '重置密码',
	api: '${BASE}/bcp-basic-data-dev/api/B/account/resetPassword',
  doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612173',
  method: 'post',
}

export const LOG_OUT = {
  name: '退出登录',
	api: '${BASE}/bcp-basic-data-dev/api/B/user/logout',
  doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=17696435',
}
